<template>
  <v-layout row wrap>
    <v-flex xl4 lg5 md12 sm12 class="card-border-right">
      <v-layout row column :reverse="$vuetify.breakpoint.smAndDown">
        <ContinuousStationComponents ref="stationComponents" :disabled="disabledStates.stations || !isInitialized" :selection="selection" :timeSeriesStations="allTimeSeriesStations" @stations="selection.stations = $event" @loading="loadingStates.stations = $event" />
        <v-divider />
        <ContinuousDateRange ref="dateRange" :disabled="disabledStates.dateRange" @dateRange="selection.dateRange = $event" :availableDateRange="availableDateRange" />
      </v-layout>
    </v-flex>
    <v-flex xl8 lg7 md12 sm12 class="card-bg-2 card-border-left">
      <TimeSeries ref="timeSeries" :disabled="disabledStates.timeSeries" @changed="onTimeSeriesSelect" :allTimeSeries="allTimeSeries" :selectedStationIds="selectedStationIds" />
    </v-flex>
  </v-layout>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const app = createNamespacedHelpers('app')
  import moment from 'moment'

  import ContinuousStationComponents from './Parameters/StationComponents/ContinuousStationComponents'
  import TimeSeries from './Parameters/TimeSeries/TimeSeries'
  import ContinuousDateRange from './Parameters/DateRange/ContinuousDateRange'

  import { debounce } from '@/helpers/performance'

  const debounceTimer = 1200

  export default {
    components: {
      ContinuousStationComponents,
      TimeSeries,
      ContinuousDateRange,
    },
    props: {
      isGeneratingReport: Boolean,
    },
    data() {
      return {
        debounceTimer,        
        isInitialized: false,
        loadingStates: {
          stations: false,
          timeseries: false,
          dateRange: false,
          downloading: false,
          selection: false,
        },
        allTimeSeriesStations: [],
        allTimeSeries: [],
        selectedTimeSeriesStations: [],
        selectedTimeSeries: {},        
        availableDateRange: {
          start: null,
          end: null,
        },
        initialSelection: {
          stations: [],
          timeSeries: [],
          dateRange: {
            start: null,
            end: null,
          },          
        },
        selection: {},
        stationComponents: {},
      }
    },
    computed: {
      queryId() {
        return this.$route.params.id
      },
      pageTitle() {
        return this.queryId ? 'View query' : 'New query'
      },
      disabledStates() {
        let disabled = {
          stations: false,
          timeSeries: false,
          dateRange: false,
        }

        if (!this.isInitialized || this.loadingStates.downloading) {
          Object.keys(disabled).forEach(key => {
            disabled[key] = true
          })

          return disabled
        }

        if (this.loadingStates.timeseries) {
          disabled.timeSeries = true
          disabled.dateRange = true
        }

        if (this.loadingStates.stations) {
          disabled.stations = true
        }

        if (this.loadingStates.dateRange) {
          disabled.timeSeries = true
        }

        return disabled
      },
      debouncedUpdate() {
        return debounce(async function exec() {          
          this.loadingStates.timeseries = false
          this.loadingStates.dateRange = false
        }, this.debounceTimer)
      },
      debouncedAnalytesSelectionUpdate() {
        return debounce(function exec(value) {
          this.selection.timeSeries = value
        }, this.debounceTimer)
      },
      selectedStationIds() {
        return this.selection.stations.map(x => x.Id)
      },
    },
    watch: {
      'selection.stations'() {
        if (!this.isInitialized || this.loadingStates.selection) return        
        this.loadingStates.timeseries = true
        this.triggerUpdate()
        this.emitSelection()
      },
      'selection.dateRange'() {        
        if (!this.isInitialized || this.loadingStates.selection) return
        //this.loadingStates.dateRange = true
        //this.triggerUpdate()
        //this.emitSelection()
      },
      loadingStates: {
        immediate: true,
        handler(value) {
          this.$emit('update:loading', value)
        },
      },
      isGeneratingReport(value) {
        this.loadingStates.downloading = value
      },
      isInitialized(value) {
        this.$emit('update:isInitialized', value)
      },
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      emitSelection() {
        this.$emit('update:selection', this.selection)
      },
      onTimeSeriesSelect(items) {
        this.selection.timeSeries = items
        this.emitSelection()
      },
      async loadSelection({
        stationIds,
        analyteNames,
        dateRange,
      }, selectionOptions) {
        this.loadingStates.selection = true
        this.debounceTimer = 0

        this.$refs.stationComponents.selectStationIds(stationIds)
        this.$refs.timeSeries.selectAnalyteNames(analyteNames)
        this.$refs.dateRange.selectDateRange(dateRange, selectionOptions)

        await this.$nextTick()
        this.emitSelection()
        await this.$nextTick()

        await this.update({
          dateRange,
          stations: stationIds,
        })

        this.loadingStates.selection = false
        this.debounceTimer = debounceTimer
      },
      updateTimeSeriesSelection(value) {
        this.loadingStates.stations = true
        this.debouncedTimeSeriesSelectionUpdate(value)
      },
      triggerUpdate() {
        this.debouncedUpdate()
      },
      updateDateRange(timeSeriesData) {
 
        if (!timeSeriesData || !timeSeriesData.length) return

        this.availableDateRange.start = moment(timeSeriesData[0].FirstRecordDate)
        this.availableDateRange.end = moment(timeSeriesData[0].LastRecordDate)

        this.availableDateRange = timeSeriesData.reduce((dateRange, current) => {
          var currentStartDate = moment(current.FirstRecordDate)
          var currentEndDate = moment(current.LastRecordDate)
          if (
            current.FirstRecordDate &&
            currentStartDate.isBefore(dateRange.start)
          ) {
            dateRange.start = currentStartDate
          }
          if (
            current.LastRecordDate &&
            currentEndDate.isAfter(dateRange.end)
          ) {
            dateRange.end = currentEndDate
          }

          return dateRange
        }, this.availableDateRange)
      },
      async initializeData(stationTimeSeriesData) {
        let stations = stationTimeSeriesData.map(x => {return {Id: x.Id, Identifier: x.Identifier, StationType: x.StationType}})
        let timeSeriesData = [].concat(...(stationTimeSeriesData.map(x => x.TimeSeries)))

        this.allTimeSeriesStations = stations
        this.allTimeSeries = timeSeriesData

        this.updateDateRange(timeSeriesData)

        this.availableDateRange.start = moment(timeSeriesData[0].FirstRecordDate)
        this.availableDateRange.end = moment(timeSeriesData[0].LastRecordDate)

        this.selection.dateRange.start = this.availableDateRange.start
        this.selection.dateRange.end = this.availableDateRange.end
      },
      makeRequestData(selection) {
        return {
          dateRange: selection.dateRange,
          stations: selection.stations.map(station => station.id),
        }
      },
      async downloadData(requestData) {
        try {
          let response = await this.$store.dispatch('multistation/fetchContinuousStationsTimeSeries', requestData)
          return response
        } catch (error) {
          console.error(error)
          this.setSnackbar({
            icon: 'error',
            text: error,
            color: 'error',
          })
        }
      },
      async fetchTimeSeriesData() {
        this.loadingStates.timeseries = true
        let stationTimeSeriesData = await this.downloadData()        

        this.initializeData(stationTimeSeriesData)
        this.loadingStates.timeseries = false
      },
      async fetchData() {
        const a = this.fetchTimeSeriesData()
        await Promise.all([a])
        this.isInitialized = true
      },
      resetSelection() {
        this.selection = JSON.parse(JSON.stringify(this.initialSelection))
      },
    },
    created() {
      this.resetSelection()
    },
    mounted() {
      this.fetchData()
    },
  }
</script>